<template>
  <div>
    <banner-component title="Mentions légales" :breadcrumbs="breadcrumbs"/>

    <section class="band">
      <div class="container container--narrow prose">
        <h2>Éditeur du site</h2>
        <dl class="facts">
          <div><dt>Site</dt><dd>{{ site.url.replace('https://', '') }}</dd></div>
          <div><dt>Éditeur</dt><dd>{{ legal.publisher }}</dd></div>
          <div v-if="legal.status"><dt>Statut</dt><dd>{{ legal.status }}</dd></div>
          <div v-if="legal.siret"><dt>SIRET</dt><dd class="tabular">{{ legal.siret }}</dd></div>
          <div v-if="legal.vatNumber"><dt>TVA</dt><dd>{{ legal.vatNumber }}</dd></div>
          <div v-if="legal.address"><dt>Adresse</dt><dd>{{ legal.address }}</dd></div>
          <div><dt>E-mail</dt><dd><a :href="'mailto:' + site.email">{{ site.email }}</a></dd></div>
          <div><dt>Téléphone</dt><dd><a :href="'tel:' + site.phoneIntl">{{ site.phone }}</a></dd></div>
          <div v-if="legal.publicationDirector"><dt>Directeur de la publication</dt><dd>{{ legal.publicationDirector }}</dd></div>
        </dl>

        <template v-if="legal.host && legal.host.name">
          <h2>Hébergeur</h2>
          <dl class="facts">
            <div><dt>Société</dt><dd>{{ legal.host.name }}</dd></div>
            <div v-if="legal.host.address"><dt>Adresse</dt><dd>{{ legal.host.address }}</dd></div>
          </dl>
        </template>

        <h2>Propriété intellectuelle</h2>
        <p>
          Les textes, images, logos et éléments graphiques de ce site sont la propriété de leur auteur, sauf mention contraire.
          Toute reproduction sans autorisation écrite est interdite. Les marques et logos d'entreprises cités appartiennent à leurs propriétaires respectifs.
        </p>

        <h2>Données personnelles et mesure d'audience</h2>
        <p>
          Ce site ne contient pas de formulaire : les données que vous nous envoyez sont celles de vos e-mails et appels, utilisées uniquement pour vous répondre.
          Pour exercer vos droits d'accès, de rectification et de suppression, écrivez à <a :href="'mailto:' + site.email">{{ site.email }}</a>.
        </p>
        <p>
          L'audience du site est mesurée avec Google Analytics et avec un outil interne qui ne dépose aucun cookie et ne conserve ni adresse IP ni identifiant d'un jour à l'autre.
        </p>

        <h2>Informations sur les guides</h2>
        <p>
          Les guides du <router-link to="/blog">blog</router-link> sont des informations générales, à jour à la date indiquée sur chacun d'eux.
          Ils ne remplacent pas l'avis d'un expert-comptable ou d'un juriste.
        </p>
      </div>
    </section>
  </div>
</template>

<script>
  import site from "@/content/site";
  import {useSeo} from "@/seo/useSeo";
  import BannerComponent from "@/components/BannerComponent.vue";

  /**
   * Mentions légales : seules les lignes renseignées dans src/content/site.js (bloc legal) sont affichées.
   * Page non indexée et absente du sitemap (voir src/content/pages.js).
   */
  export default {
    name: 'LegalView',
    components: {BannerComponent},
    setup() {
      useSeo({path: '/mentions-legales'});
    },
    data: function () {
      return {
        site,
        legal: site.legal,
        breadcrumbs: [
          {name: 'Accueil', path: '/'},
          {name: 'Mentions légales', path: '/mentions-legales'}
        ],
      }
    }
  }
</script>

<style lang="stylus" scoped>
@import '~/src/common/style/constants.styl';

// Le premier titre ouvre la page : ni filet ni marge au-dessus
.prose > h2:first-child
  margin-top 0
  padding-top 0
  border-top 0

.facts
  margin 16px 0 0
  border-top 2px solid INK
  > div
    display grid
    gap 2px 24px
    padding 10px 0
    border-bottom 1px solid RULE
  dt
    color MUTED
    font-size 0.95rem
  dd
    margin 0

@media (min-width: TABLET_SIZE)
  .facts > div
    grid-template-columns 220px 1fr
</style>
